/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import '../../../atoms/heading/css/heading';
import '../../../atoms/text/css/text';
import './fieldset.scss';
import './modifier/cms.scss';
